import { z } from 'zod';
import { materialLookupCfgSchema } from './macros/material-lookup.zod';

export const macroSchema = z.lazy(() => z.discriminatedUnion('type', [
    materialLookupCfgSchema,
]));
